import Logo from '../assets/images/logo.png';

export default function AppSkeleton() {
  return (
    <div style={{ backgroundColor: '#0EA28A', minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px', marginRight: '16px', padding: '4px 0' }}>
        <span style={{ height: '33px' }} />
      </div>
      <header
        style={{
          backgroundColor: '#faf7f5',
          paddingTop: '24px',
          paddingBottom: '16px',
          boxShadow: '0px 0px 16px rgba(140, 138, 136, 0.5), 8px 8px 32px rgba(89, 88, 87, 0.25)',
        }}
      >
        <div style={{ maxWidth: '1536px', margin: '0 auto', padding: '0 24px' }}>
          <img src={Logo} alt="" width={248} height={54} />
        </div>
      </header>
      <div style={{ padding: '24px' }}>
        <div style={{ backgroundColor: '#fff', borderRadius: '50px', minHeight: '60vh' }} />
      </div>
    </div>
  );
}
